import { Link, useParams } from "react-router";
import Logo from "../../../assets/texpress.png";
import { cn } from "@/lib/utils";
import { Card, CardContent } from "@/components/ui/card";

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Check, Eye, EyeClosed, Loader2, Mail, X } from "lucide-react";
import { useEffect, useState } from "react";
import { OfficeIcon } from "@/assets";

import { joinViaInvite } from "@/services/Settings.service";

import { useMutation } from "@tanstack/react-query";
const Accept = () => {
  const { token } = useParams();

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [errorFailed, setErrorFailed] = useState(false);

  const handleJoin = async () => {
    setLoading(true);
    await joinViaInvite(token)
      .then((response) => {
        setErrorFailed(false);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setErrorMsg(error?.response?.data?.message);
        setErrorFailed(true);
      });
  };

  useEffect(() => {
    handleJoin();
  }, []);

  return (
    <div className="flex flex-col  items-center justify-center gap-6 min-h-svh bg-muted ">
      <div className="flex flex-col gap-6">
        <Link to="/" className="flex items-center justify-center h-10">
          <img src={Logo} className="h-10" />
        </Link>

        <div className={cn("flex flex-col gap-6")}>
          <Card className="w-full lg:w-[542px] p-12 rounded-[12px]">
            <CardContent className="items-center flex justify-center">
              {loading ? (
                <Loader2 className="animate-spin w-8 h-8" />
              ) : (
                <div className="flex flex-col justify-center items-center gap-8">
                  <div
                    className={cn(
                      "w-[64px] h-[64px] rounded-full flex items-center justify-center",
                      errorFailed ? "bg-error-0" : "bg-green-0"
                    )}
                  >
                    {errorFailed ? (
                      <X className="text-error" />
                    ) : (
                      <Check className="text-green" />
                    )}
                  </div>
                  <div className="grid gap-3">
                    <h5 className="text-center text-primary-3 text-2xl font-medium">
                      {errorFailed ? errorMsg : "Successfully Joined Team"}
                    </h5>
                    {errorFailed ? (
                      <>
                        <p className="text-center text-[#565C6B] text-sm">
                          kindly reach out to the admin to resend the invite
                        </p>
                        <Link to="/dashboard" className="text-primary text-sm flex items-center text-center justify-center">
                          <ArrowLeft /> Go Back to Dashboard
                        </Link>
                      </>
                    ) : (
                      <p className="text-center text-[#565C6B] text-sm">
                        Congratulations, you have been added to Team, Kindly go
                        to{" "}
                        <Link to="/dashboard" className="text-primary text-sm">
                          dashboard
                        </Link>{" "}
                        page to proceed.
                      </p>
                    )}
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Accept;
